export const normalizeTitle = (raw: string): string => {
  if (!raw) return ''

  let s = raw.replace(/[_-]+/g, ' ')
  s = s.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
  s = s.trim().replace(/\s+/g, ' ')
  if (!s) return ''

  return s.charAt(0).toUpperCase() + s.slice(1)
}

